<script lang="ts">
  import { href } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Email/Email.json"
</script>

{#each data.emailappfilterdata as emailItem}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <li class="nav-item">
    <a class={emailItem.class} {href}>
      <span class="title">
        <i class={emailItem.icon} />
        {emailItem.name}
      </span>
      {#if emailItem.badge}
        <span class="badge pull-right">{emailItem.badge}</span>
      {/if}
    </a>
  </li>
{/each}
